module.exports = __webpack_public_path__ + "static/img/IE@2x.62dc32e6.jpg";